/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
// import { ToDoLists } from '../../../config/ToDoLists'
import ToDoListService from '../../../../../../libs/api/services/ToDoListService'

export default function ToDoSelector({ onChange, defaultValue, mode }) {

    const [todos, setTodos] = useState()
    const [properties, setProperties] = useState(defaultValue ? defaultValue : undefined)
    const [cMode, setCMode] = useState(mode ? mode : 'All')

    const LoadToDoLists = async () => setTodos(await ToDoListService.ListToDoLists().catch((e) => console.log('Failed to load to do lists', e)))

    useEffect(() => { LoadToDoLists() }, [])

    const _handleSetGroup = (g) => {
        if (onChange) onChange({ ...properties, group: g, item: undefined, list: undefined })
        setProperties({ ...properties, group: g, item: undefined, list: undefined })
    }

    const _handleSetItem = (i) => {
        if (onChange) onChange({ ...properties, list: i, item: undefined })
        setProperties({ ...properties, list: i, item: undefined })
    }

    const _handleSetStatus = (s) => {
        if (onChange) onChange({ ...properties, item: s })
        setProperties({ ...properties, item: s })
    }

    // useEffect(() => {
    //     if (onChange && properties) onChange(properties)
    // }, [properties])
    useEffect(() => {
        if (defaultValue) setProperties(defaultValue)
    }, [defaultValue])
    // if (!todos) return
    return (
        <div>
            {/* {properties && todos && JSON.stringify(todos.find(a => a.resource.id === properties.group))} */}
            {/* {properties && todos && JSON.stringify(todos.find(a => a.resource.resource.id === properties.group).resources)} */}
            {/* {JSON.stringify(todos[0].resources)} */}
            {
                cMode === 'All' || cMode === 'no-status' || cMode === 'list'
                    ?
                    <div>
                        <b>List</b>
                        <select
                            onChange={(e) => _handleSetGroup(e.target.value)}
                            className='form-control form-control-sm'>
                            <option></option>
                            {todos && todos.map((g) => <option selected={properties && properties.group && properties.group === g.resource.resource.id} value={g.resource.resource.id} key={g.resource.resource.id}>{g.resource.resource.group}</option>)}
                        </select>
                    </div>
                    :
                    <></>
            }
            {
                cMode === 'All' || cMode === 'no-status'
                    ?
                    <div>
                        <b>Item</b>
                        <select
                            onChange={(e) => _handleSetItem(e.target.value)}
                            className='form-control form-control-sm'>
                            <option></option>
                            {todos && properties && properties.group ? todos.find(a => a.resource.resource.id === properties.group).resources
                                .map((i) => <option selected={properties && properties.list && properties.list === i.resource.resource.id} value={i.resource.resource.id} key={i.resource.resource.id}>{i.resource.resource.list}</option>) : undefined}
                        </select>
                    </div>
                    :
                    <></>
            }
            {
                cMode === 'All' || cMode === 'status'
                    ?
                    <div>
                        <b>Status</b>
                        <select
                            onChange={(e) => _handleSetStatus(e.target.value)}
                            className='form-control form-control-sm'>
                            <option></option>
                            {todos && properties && properties.group && properties.list && todos.find(a => a.resource.resource.id === properties.group).resources
                                .find((x) => x.resource.resource.id === properties.list).resources
                                .map((i) => <option selected={properties && properties.item && properties.item === i.resource.id} value={i.resource.id} key={i.resource.id}>{i.resource.item}</option>)
                            }
                        </select>
                    </div>
                    :
                    <></>
            }

        </div>
    )
}
